<template>
  <div class="font-h6">
    <div class="align-center-xs">
      <img src="@/assets/img/icons/box-growth.png" />
      <h4 class="strong color-black mb-0">Growth</h4>
      <h6 class="color-lightgray mb-0">For Email + Linkedin Outreach</h6>
      <br />
      <h1 class="strong color-black mb-0">
        <span class="line-through color-lip font-h3 strong" v-if="price != '..'">${{ price * 2 }}</span> ${{ price }}
        <span class="font-h6 shy">per month</span>
      </h1>
      <!-- <h6>{{ price_description }}</h6> -->

      <!-- Curent tier -->
      <button
        v-if="billing.subscription && billing.subscription.plan_type.startsWith('growth')"
        class="btn color-black div-border no-border btn-large strong my-20 free-height py-10 max-full-width"
        style="width: 300px; background-color: #f0c419"
        @click="$emit('switch', 'growth')"
      >
        <span class="font-h5 strong">Current tier</span>
      </button>

      <!-- Switch plan -->
      <button
        v-else-if="billing.subscription"
        class="btn btn-primary btn-large no-border strong my-20 free-height py-10 max-full-width"
        v-ripple
        style="width: 300px"
        @click="$emit('switch', 'growth')"
      >
        <span class="font-h5 strong">SUBSCRIBE</span>
      </button>

      <!-- Selected plan -->
      <button
        v-else-if="show_upgrade_form"
        class="btn btn-warning btn-large no-border strong my-20 free-height py-10 max-full-width"
        style="width: 300px; background-color: #f0c419"
      >
        <span class="font-h5 strong">SELECTED</span>
      </button>

      <!-- Subscribe plan -->
      <button
        v-else
        class="btn btn-primary btn-large no-border strong my-20 free-height py-10 max-full-width"
        v-ripple
        style="width: 300px"
        @click="$emit('choose', 'growth', 'upgrade')"
      >
        <span class="font-h5 strong">SUBSCRIBE</span>
      </button>

      <h5 class="strong mb-15 color-black font-h5s">All in Entry, plus +</h5>

      <div class="inline-block align-left">
        <div v-for="p in profits" :key="p" class="flex items-center mb-20">
          <i class="la la-check mr-10 big-text"></i>
          <h6 class="mb-0 flex-auto" :class="{ strong: p.startsWith('Linkedin') }">{{ p }}</h6>
        </div>
      </div>

      <h6 class="color-primary color-hover-success inline-block block-xs pointer align-center-xs strong" @click="$emit('choose', 'growth', 'detail')">
        Want to know what is included more in detail?
      </h6>
    </div>
  </div>
</template>

<script>
import request from "@/service";
import types from "@/constants/types";

export default {
  name: "GrowthPlan",
  components: {},
  props: {
    billing: Object,
    billing_cycle: String,
    show_upgrade_form: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      profits: [
        "1000 AI Sales videos + AI Voice Cloning",
        "Linkedin Heyreach native integration",
        "Screen recording 60 min + Scheduling",
        "Sales academy",
        "Premium support",
        "All integrations available",
        "Add Minutes for $0.15/min",
      ],
    };
  },
  async mounted() {},
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    the_plan() {
      let p = this.billing.packages.find((p) => p.plan_type == "growth_" + this.billing_cycle);
      if (p) return p;
      return {};
    },
    price() {
      if (this.the_plan && this.the_plan.plan_price) {
        let price = this.the_plan.plan_price.split("/")[0];
        return price * this.the_plan.minimum_seats;
      } else return "..";
    },
    price_description() {
      if (this.the_plan.billed == "monthly") return "per month";
      else if (this.the_plan.billed == "yearly") return "per year";
      else return "..";
    },
  },
  methods: {},
};
</script>
